<div class="flex h-full flex-col">
  <!-- <div class="ml-2">
    <uni-breadcrumb></uni-breadcrumb>
  </div> -->
  <div class="mt-3 flex grow min-h-0 gap-2">
    <!-- COLLAPSIBLE SIDEBAR WRAPPER -->
    <div *ngIf="items.length" class="sidebar-wrapper h-full" [class.collapsed]="isSidebarCollapsed">
      <!-- TOGGLE BUTTON WITH ARROW ICON -->
      <div class="sidebar-toggle" (click)="toggleSidebar()" [title]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
        <i class="pi" [class.pi-angle-left]="!isSidebarCollapsed" [class.pi-angle-right]="isSidebarCollapsed"></i>
      </div>
      <!-- SIDEBAR CONTAINER WITH MENU AND BUTTONS -->
      <div class="sidebar-container h-full">
        <p-panelMenu styleClass="layout-submenu" [model]="items" [multiple]="true"></p-panelMenu>
        <!-- <button
          *ngIf="showScanIntoShipPrepButton"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-4"
          icon="pi pi-qrcode"
          (click)="scanIntoShipPrep()"
        >
          <span>Scan into Ship Prep</span>
        </button> -->
        <!-- Ship Frequencies button (visible on Ship Prep, Staging/Vouchering, Shipping/Invoicing) -->
        <button
          *ngIf="showShipFrequenciesButton"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-4"
          icon="pi pi-calendar"
          (click)="editShipFrequencies()"
        >
          <span>Ship Frequencies</span>
        </button>
        <!-- Scanner panel for Ship Prep page -->
        <div *ngIf="showScanIntoShipPrepButton" class="mt-8">
          <uni-scanner-input
            #shipPrepScanner
            label="Scan to Ship Prep..."
            busyLabel="Processing..."
            [disabled]="scannerDisabled"
            [searchFn]="scannerSearchFn"
            (scanResult)="onScannerResult($event)"
            (scanError)="onScannerError($event)"
          ></uni-scanner-input>
        </div>
        <!-- Scanner panel for Scan Station page -->
        <div *ngIf="showScanStationScanner" class="mt-8">
          <uni-scanner-input
            #shipPrepScanner
            label="Scan to Shipment Bin..."
            busyLabel="Processing..."
            [disabled]="scannerDisabled"
            [searchFn]="scannerSearchFn"
            (scanResult)="onScannerResult($event)"
            (scanError)="onScannerError($event)"
          ></uni-scanner-input>
        </div>
        <!-- Scanner panel for Addon Bin Process page -->
        <div *ngIf="showAddonBinScanner" class="mt-8">
          <uni-scanner-input
            [label]="addonBinScannerLabel"
            busyLabel="Processing..."
            [disabled]="scannerDisabled"
            [searchFn]="scannerSearchFn"
            (scanResult)="onScannerResult($event)"
            (scanError)="onScannerError($event)"
          ></uni-scanner-input>
        </div>
        <!-- Scanner panel for Jo Pull Apply page -->
        <div *ngIf="showJoPullApplyScanner" class="mt-8">
          <uni-scanner-input
            #joPullApplyScannerInput
            label="Scan Inventory..."
            busyLabel="Processing..."
            [disabled]="joPullApplyScannerDisabled"
            [searchFn]="joPullApplyScannerSearchFn"
            (scanResult)="onJoPullApplyScannerResult($event)"
            (scanError)="onJoPullApplyScannerError($event)"
          ></uni-scanner-input>
        </div>
        <!-- Jo Pull Apply buttons -->
        <button
          id="joPullConfirmSelectionButton"
          *ngIf="showJoPullApplyButtons"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-4"
          icon="pi pi-check"
          [disabled]="!canConfirmSelection"
          (click)="confirmSelection()"
        >
          <span>Confirm Selection</span>
        </button>
        <div *ngIf="showJoPullApplyButtons" class="mt-6 flex items-center justify-center">
          <p-checkbox
            [(ngModel)]="shouldPrintBarcodesApply"
            (ngModelChange)="onShouldPrintBarcodesApplyChange()"
            name="shouldPrintBarcodesApply"
            inputId="shouldPrintBarcodesApply"
            [binary]="true"
          ></p-checkbox>
          <label for="shouldPrintBarcodesApply" class="ml-2 text-sm">Automatically Print Barcodes</label>
        </div>
      </div>
    </div>
    <!-- MAIN CONTENT AREA -->
    <div class="ml-4 flex grow flex-col min-h-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
